import { render, staticRenderFns } from "./PaymentOrderDetail.vue?vue&type=template&id=55ecd7c2&scoped=true"
import script from "./PaymentOrderDetail.vue?vue&type=script&lang=js"
export * from "./PaymentOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrderDetail.vue?vue&type=style&index=0&id=55ecd7c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ecd7c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ecd7c2')) {
      api.createRecord('55ecd7c2', component.options)
    } else {
      api.reload('55ecd7c2', component.options)
    }
    module.hot.accept("./PaymentOrderDetail.vue?vue&type=template&id=55ecd7c2&scoped=true", function () {
      api.rerender('55ecd7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WayBill/PaymentOrderDetail.vue"
export default component.exports